import { Filter } from "../../../models/filter.model";

/**
 * Header sorting shared by the admin Accounts and Organisations lists
 * (AV-17963). The state lives on the shared Filter so the export dialog can
 * follow the on-screen order, and so the lists' existing filter watcher
 * reloads them - the same debounced path the quick-filter chips take.
 */
export class AdminListSort {
    constructor(
        private readonly keys: { [columnId: string]: string },
        private readonly filter: () => Filter | undefined
    ) {}

    get sort(): string | null {
        const filter = this.filter();
        return (filter && filter.sort) || null;
    }

    get direction(): "asc" | "desc" {
        const filter = this.filter();
        return filter && filter.sortDir == "asc" ? "asc" : "desc";
    }

    sortable(column: { id: string }): boolean {
        return !!this.keys[column.id];
    }

    /** First click sorts high to low, second flips, third clears. */
    toggle(column: { id: string }): void {
        const filter = this.filter();
        const key = this.keys[column.id];
        if (!filter || !key) return;
        if (this.sort !== key) {
            filter.sort = key;
            filter.sortDir = "desc";
        } else if (this.direction == "desc") {
            filter.sortDir = "asc";
        } else {
            filter.sort = null;
            filter.sortDir = "desc";
        }
    }

    icon(column: { id: string }): string {
        const key = this.keys[column.id];
        if (!key || this.sort !== key) return "unfold_more";
        return this.direction == "desc" ? "arrow_downward" : "arrow_upward";
    }

    /** Stats are missing until the nightly aggregate runs; show them as 0. */
    static statNumber(row: any, key: string): string {
        const stats: any = (row && row.stats) || {};
        return Number(stats[key] || 0).toLocaleString();
    }
}
